import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { barrerToken } from './auth/auth';

@Injectable()
export class AuthTokenSalesforceInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.endsWith('https://suratech-ventas-xapi-qaoaut.us-e1.cloudhub.io/v1/security/token')) {
           
                console.log('Interceptando la solicitud de autenticación...');

            return of(new HttpResponse({ status: 200, body: barrerToken }));
        }

        // Pass through any requests not handled above
        return next.handle(req);
    }
}